import QRCode from 'qrcode'
import logoUrl from '../../assets/images/VN.png'
import { drawCameraIcon } from './drawCameraIcon'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const drawLabel = async (data = {}, typedata) => {
    const {
        orderId, total, pos, color, size, side, posColor, posBackground, sideColor,
        sideBackground, type, code, loc, noCard, isSpecialTag, brand_name, is_no_card,
        isFastProduction, line_ship_label, overtime, hwUSPSArea, isCutoff, order_type,
        tags = [],
    } = { ...data }

    const arrCountry = [
        'GB', 'AT', 'BE', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
        'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'NL', 'NO', 'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'CH', 'CA'
    ]
    const sizeUVHEART = [
        { '1 HOLDER+ 2 CANDLES': '1HD + 2CD' },
        { '1 HOLDER+ 4 CANDLES': '1HD + 4CD' },
        { '1 HOLDER+ 6 CANDLES': '1HD + 6CD' },
        { '1 HOLDER+ 8 CANDLES': '1HD + 8CD' },
        { '1 HOLDER+ 10 CANDLES': '1HD + 10CD' },
        { '1 HOLDER+ 15 CANDLES': '1HD + 15CD' },
        { '1 HOLDER+ 20 CANDLES': '1HD + 20CD' }
    ]

    const sizeAcrylicPlaque = {
        '3.9in puzzle left': '3.9 Puzzle L',
        '4.9in puzzle left': '4.9 Puzzle L',
        '5.9in puzzle left': '5.9 Puzzle L',

        '3.9in puzzle right': '3.9 Puzzle R',
        '4.9in puzzle right': '4.9 Puzzle R',
        '5.9in puzzle right': '5.9 Puzzle R',

        '3.9in heart left': '3.9 Heart L',
        '4.9in heart left': '4.9 Heart L',
        '5.9in heart left': '5.9 Heart L',

        '3.9in heart right': '3.9 Heart R',
        '4.9in heart right': '4.9 Heart R',
        '5.9in heart right': '5.9 Heart R',
    }

    const LABEL_WIDTH = 230
    const LABEL_HEIGHT = 170

    const MID_X = typedata === 'admin' ? (LABEL_WIDTH / 2 - 20) :(LABEL_WIDTH / 2)
    const QR_WIDTH = typedata === 'admin' ? (LABEL_WIDTH / 2 - 20) : (LABEL_WIDTH / 2)
    const QR_Y = 55

    const qrDataUrl = await QRCode.toDataURL(orderId, {
        width: 200, margin: 3, color: isSpecialTag ? {
            dark: '#6d1212',
            light: '#ffffffff'
        } : ''
    })
    const qrDataImage = await _makeImage(qrDataUrl)

    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT

    const ctx = canvas.getContext('2d')

    ctx.beginPath()
    ctx.rect(0, 0, LABEL_WIDTH, LABEL_HEIGHT)
    ctx.fillStyle = 'white'
    ctx.fill()

    ctx.drawImage(qrDataImage, 0, QR_Y, QR_WIDTH, QR_WIDTH)

    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = '22px Arial'
    ctx.fillText(orderId, 12, 30)

    ctx.beginPath()
    ctx.fillStyle = posBackground
    ctx.rect(MID_X + 40, 12, QR_WIDTH, 20)
    ctx.fill()

    ctx.fillStyle = posColor
    ctx.fillText(`${pos}/${total}`, MID_X + 50, 30)

    ctx.beginPath()
    ctx.fillStyle = sideBackground
    ctx.rect(MID_X, QR_Y + 51, QR_WIDTH, 20)
    ctx.fill()

    if (type.length < 15) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '22px Arial'
        ctx.fillText(type, 12, 55)
    } else if (type.length >= 15 && type.length < 20) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '20px Arial'
        ctx.fillText(type, 12, 55)
    } else {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = '14px Arial'
        ctx.fillText(type, 12, 55)
    }

    if (!color) {
        ctx.beginPath()
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        if (brand_name && brand_name.length < 10) {
            ctx.font = 'bolder 20px Arial'
        } else {
            ctx.font = 'bolder 15px Arial'
        }
        ctx.fillText(brand_name, MID_X, QR_Y + 28)
    }

    ctx.beginPath()
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = '20px Arial'

    if (color) {
        ctx.fillText(color, MID_X, QR_Y + 28)
    }

    if (size) {
        let sizeUV = size
        if ((size !== 'Default' && size !== 'DEFAULT') && (type === 'UV_HEART_HOLDER' || type === 'UV_HOLDER' || type === 'UV_HOLDER_CANDLE' || type === 'UV_HEART_HOLDER_CANDLE')) {
            const sizeObject = sizeUVHEART.find(item => item[size])
            sizeUV = sizeObject[size]
        }

        if (['ACRYLIC_PLAQUE'].includes(type)) {
            const vSize = size.trim().toLowerCase()
            sizeUV = sizeAcrylicPlaque[vSize]
        }

        ctx.fillText(sizeUV, MID_X, QR_Y + 48)
    }

    ctx.fillStyle = sideColor ? sideColor : sideBackground === 'black' ? 'white' : 'black'
    ctx.fillText(side, MID_X, QR_Y + 68)

    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    if (loc) ctx.fillText(arrCountry.includes(loc) ? 'EU' : loc, MID_X, QR_Y + 88)

    //line-ship
    ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
    ctx.font = 'bolder 15px Arial'
    ctx.fillText(line_ship_label, 10, QR_Y + 100)

    if (hwUSPSArea) {
        ctx.fillStyle = isSpecialTag ? '#6d1212' : 'black'
        ctx.font = 'bolder 14px Arial'

        ctx.fillText(hwUSPSArea, 10 + ctx.measureText(line_ship_label).width + 17, QR_Y + 100)
    }

    if (Array.isArray(tags) && tags.includes('made_vn')) {
        const PADDING = 40;
        const xRight = LABEL_WIDTH - 30 - PADDING;
        const logoImage = await _makeImage(logoUrl)
        ctx.drawImage(logoImage, xRight, QR_Y + 85, 30, 30);
    }

    if (noCard || is_no_card) {
        ctx.font = 'bolder 26px Arial'
        ctx.fillText('No Card', MID_X, QR_Y + 113)
    }

    const bottomTagY = QR_Y + (line_ship_label ? 115 : 100)
    ctx.font = 'bolder 15px Arial'

    // Icon máy ảnh nằm ở vị trí text NHANH cũ (bên trái) — chỉ hiện khi đơn đang
    // chờ chụp ảnh (photo_requested), KHÔNG hiện cho photo_updated/confirmed.
    // Cao bằng chữ, nền trong suốt (overlay).
    const PHOTO_TAGS = ['photo_requested']
    const isRequestPhoto = Array.isArray(tags) && tags.some(t => PHOTO_TAGS.includes(t))
    if (isRequestPhoto) {
        const camSize = 12
        drawCameraIcon(ctx, 10, bottomTagY - camSize, camSize)
    }

    // Đơn tiktok chắc chắn là nhanh -> chỉ hiện TIKTOK.
    // Đơn nhanh (không phải tiktok) -> hiện NHANH.
    // Hai text này không xuất hiện đồng thời; text dời sang vị trí TIKTOK cũ.
    const fastLabel = (order_type && order_type.toLowerCase() === 'tiktok')
        ? 'TIKTOK'
        : ((isFastProduction && typedata === 'admin') ? 'NHANH' : null)
    if (fastLabel) {
        ctx.fillStyle = 'red'
        ctx.font = 'bolder 15px Arial'
        const textX = 10 + ctx.measureText('NHANH').width + 5
        ctx.fillText(fastLabel, textX, bottomTagY)
    }

    if(isCutoff && typedata === 'admin'){
        ctx.fillStyle = 'black'
        ctx.font = 'bolder 15px Arial'
        const text = 'CUTOFF'
        const textWidth = ctx.measureText(text).width
        // ctx.fillText(text, canvas.width - textWidth, QR_Y + 88)
        ctx.fillText(text, canvas.width - textWidth, QR_Y + (line_ship_label ? 115 : 100))
    }

    return canvas.toDataURL()
}

export default drawLabel
